"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PiercingShotAbilityHandler = exports.PiercingShotActorAbilityFactory = exports.PiercingShotAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Registries_1 = require("../../core/state/Registries");
class PiercingShotAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PiercingShot;
        this.__typeName = "PiercingShot";
    }
}
exports.PiercingShotAbilityArgs = PiercingShotAbilityArgs;
let PiercingShotActorAbilityFactory = class PiercingShotActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PiercingShot", "OneEnemies", 0);
    }
};
PiercingShotActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PiercingShot")
], PiercingShotActorAbilityFactory);
exports.PiercingShotActorAbilityFactory = PiercingShotActorAbilityFactory;
let PiercingShotAbilityHandler = class PiercingShotAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "ElegantArrow",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 45)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new __1.VulnerabilityEffectArgs(1),
                    duration: Duration_1.Duration.Turns(5),
                    sequence
                });
            }
        });
    }
};
PiercingShotAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PiercingShot)
], PiercingShotAbilityHandler);
exports.PiercingShotAbilityHandler = PiercingShotAbilityHandler;
